var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, html, css } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import '../card/SimpleWorkflowExecutionCard';
let WorkflowExecutionList = class WorkflowExecutionList extends LitElement {
    constructor() {
        super(...arguments);
        this.workflow_executions = [];
        this.id_selected = null;
    }
    render() {
        return html `
      <div class="execution-list">
        ${this.workflow_executions.map((execution) => html `
            <simple-workflow-execution-card
              .workflow_execution=${execution}
              .selected=${execution.workflow_execution_id === this.id_selected}
            ></simple-workflow-execution-card>
          `)}
      </div>
    `;
    }
};
WorkflowExecutionList.styles = css `
    .execution-list {
      display: flex;
      flex-direction: column;
      gap: 8px;
    }
  `;
__decorate([
    property({ type: Array })
], WorkflowExecutionList.prototype, "workflow_executions", void 0);
__decorate([
    property({ type: String })
], WorkflowExecutionList.prototype, "id_selected", void 0);
WorkflowExecutionList = __decorate([
    customElement('workflow-execution-list')
], WorkflowExecutionList);
export { WorkflowExecutionList };
//# sourceMappingURL=WorkflowExecutionList.js.map